var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "settings-container"
  }, [_c('substrate-mount', {
    attrs: {
      "flat": ""
    }
  }, [_c('payment-grade-settings', {
    attrs: {
      "rating": _vm.payloadData.rating
    },
    on: {
      "click": function click($event) {
        return _vm.handleChangeSenderField('rating');
      },
      "submit": _vm.handleChangeGradeSettings
    }
  }), _c('toggle-panel', {
    attrs: {
      "title": _vm.$t(_vm.payloadData.name.text)
    },
    on: {
      "click": function click($event) {
        return _vm.handleChangeSenderField('name');
      }
    },
    model: {
      value: _vm.payloadData.name.selected,
      callback: function callback($$v) {
        _vm.$set(_vm.payloadData.name, "selected", $$v);
      },
      expression: "payloadData.name.selected"
    }
  }, [_c('user-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _c('toggle-panel', {
    attrs: {
      "title": _vm.$t(_vm.payloadData.email.text)
    },
    on: {
      "click": _vm.handleChangeEmailSender
    },
    model: {
      value: _vm.payloadData.email.selected,
      callback: function callback($$v) {
        _vm.$set(_vm.payloadData.email, "selected", $$v);
      },
      expression: "payloadData.email.selected"
    }
  }, [_c('mail-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _c('toggle-panel', {
    attrs: {
      "title": _vm.$t(_vm.payloadData.phone.text)
    },
    on: {
      "click": function click($event) {
        return _vm.handleChangeSenderField('phone');
      }
    },
    model: {
      value: _vm.payloadData.phone.selected,
      callback: function callback($$v) {
        _vm.$set(_vm.payloadData.phone, "selected", $$v);
      },
      expression: "payloadData.phone.selected"
    }
  }, [_c('call-phone-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _c('toggle-panel', {
    attrs: {
      "title": _vm.$t(_vm.payloadData[_vm.selectedItem].text)
    },
    on: {
      "click": function click($event) {
        return _vm.handleChangeSenderField(_vm.selectedItem);
      }
    },
    model: {
      value: _vm.hasSelectedItem,
      callback: function callback($$v) {
        _vm.hasSelectedItem = $$v;
      },
      expression: "hasSelectedItem"
    }
  }, [_vm.selectedItem === 'address' ? _c('pin-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }) : _c('comment-text-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _c('div', {
    staticClass: "popup-selectable-container",
    attrs: {
      "slot": "title"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "selectable-container",
    on: {
      "click": _vm.handleClickToSelectableOption
    }
  }, [_c('div', {
    staticClass: "selectable-title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.payloadData[_vm.selectedItem].text)) + " ")]), _c('div', {
    staticClass: "selectable-icon"
  }, [_c('chevron-bottom-icon', {
    attrs: {
      "fill": "white"
    }
  })], 1)]), _vm.isDesktop ? _c('capusta-popup', {
    ref: "capustaPopup"
  }, [_c('ul', {
    staticClass: "popup_list"
  }, _vm._l(_vm.selectList, function (selectValue) {
    return _c('li', {
      key: selectValue.text,
      staticClass: "popup_list-item",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handleSelectOption(selectValue);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(selectValue.text)) + " ")]);
  }), 0)]) : _c('cs-dialog', {
    model: {
      value: _vm.isShownSelectableOptions,
      callback: function callback($$v) {
        _vm.isShownSelectableOptions = $$v;
      },
      expression: "isShownSelectableOptions"
    }
  }, [_c('dialog-list-layout', _vm._l(_vm.selectList, function (option) {
    return _c('option-panel', {
      key: option.key,
      attrs: {
        "option": option
      },
      on: {
        "click": _vm.handleSelectOption
      }
    });
  }), 1)], 1)], 1)], 1), _c('promo-code-settings')], 1), _c('div', {
    staticClass: "submit-button-container"
  }, [_c('cs-button', {
    attrs: {
      "width": "100%",
      "type": "secondary"
    },
    on: {
      "click": _vm.handlePreview
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.preview')) + " ")])], 1), _c('payment-auto-redirection-confirm', {
    on: {
      "confirm": function confirm($event) {
        return _vm.handleChangeSenderField('email');
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }